
















import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'
import EventHero from '@ui/Event/EventHero'
import SpaceDisplay from '@ui/Space/SpaceDisplay'

settings =
  name: 'SpaceShow'

  resources:
    space:
      resourceName: 'space'
      slug: 'spaces/:spaceId'

  components: {
    LoadingIndicator,
    EventHero,
    SpaceDisplay,
  }

  vue:
    data: ->
      modal:
        show: true

    computed:
      typeIsSampling: -> @space.type is 'product_sampling'

    methods:
      hiClose: -> @$router.back()

      hiNavToEditStep: (step) ->
        name = 'SamplingSpaceEditPage' if @typeIsSampling
        name ||= 'OnsiteSpaceEditPage'
        params = { spaceId: @space.id }
        query = { step }
        @$router.push { name, params, query }

export default VueOptions.vue settings
